var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#ccc",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 160,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 40,
    x2: 160,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 160,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 120,
    x2: 160,
    y2: 120
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 160,
    y2: 160
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#333",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 160,
    x2: 160,
    y2: 160
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 160
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,160 Q40,80 80,120 T160,40",
    stroke: "#ff6b6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,120 Q40,160 80,80 T160,0",
    stroke: "#4ecdc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,80 Q40,40 80,100 T160,60",
    stroke: "#45b7d1"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 160,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 120,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 40,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 120,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 0,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 80,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 100,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 4
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 190,
    fontSize: 12,
    textAnchor: "middle",
    fill: "#333"
  }, "virus.sucks plotter")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71c561368db196e8a9b62a84df1ceb5b.svg";
export { ForwardRef as ReactComponent };